module.exports = __webpack_public_path__ + "img/data-variable.63ea97ef.svg";